// @ts-nocheck
import getImageSize from "@toolkit/Framework/Common/Utilities/getImageSize";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* Store Custom Code - Start */
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const design: Styleguide["design"] = {
    product: {
        image: {
            small: getImageSize(210),
            medium: getImageSize(768),
            large: getImageSize(1200),
        },
        /* Store Custom Code - Start */
        list: {
            contentSpacing: pxToRem(4),
        },
        /* Store Custom Code - End */
    },
    category: {
        image: {
            small: getImageSize(768),
        },
    },
    typography: {
        fontFamily: {
            title: `Ubuntu, Arial, Helvetica, sans-serif`, // Store Custom Code
            base: `"Open Sans", Arial, Helvetica, sans-serif`, // Store Custom Code
        },
    },
};

export default design;
